import * as FileSaver from 'file-saver'
import moment from 'moment'
import * as XLSX from 'xlsx-js-style'
import { styleTableSheet } from 'utils/excelStyle'

export const handleDownloadExcelWithRTK = async (
  warehouseName,
  activeTab,
  initialData,
  setIsDownload,
  setFirstRows,
  setTotalRows,
  triggerFetchFunction,
  queryParams,
  currentRowsPerPage = 10,
) => {
  const warehouseTitle = warehouseName?.toUpperCase() ?? '-'
  const activeTabTitle = activeTab?.toUpperCase() ?? '-'

  setIsDownload(false)
  setFirstRows(0)
  setTotalRows(0)

  setTimeout(async () => {
    try {
      setIsDownload(true)

      const totalItems = initialData?.totalItems || 0
      setTotalRows(totalItems)
      setFirstRows(0)

      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      const bookType = 'xlsx'

      const exportHeader = ['Nama Inventori', 'Jumlah', 'Satuan']
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([exportHeader])

      let allData = []
      let currentPage = 0
      let fetchedItems = 0

      while (fetchedItems < totalItems) {
        try {
          const result = await triggerFetchFunction({
            ...queryParams,
            page: currentPage,
            size: currentRowsPerPage,
          })

          const pageData = result?.data?.items || []

          if (pageData.length === 0) {
            break
          }

          allData = [...allData, ...pageData]
          fetchedItems += pageData.length

          setFirstRows(Math.min(fetchedItems, totalItems))

          currentPage++

          if (fetchedItems < totalItems) {
            await new Promise((resolve) => setTimeout(resolve, 150))
          }
        } catch (error) {
          console.error(`Error fetching page ${currentPage}:`, error)
          break
        }
      }

      const excelData = allData.map((row) => [
        row?.nameItem ?? '-',
        row?.total ?? 0,
        row?.unit ?? '-',
      ])

      XLSX.utils.sheet_add_aoa(ws, excelData, { origin: 'A2' })
      styleTableSheet(ws)

      setFirstRows(Math.min(allData.length, totalItems))

      setTimeout(() => {
        wb.Sheets['data'] = ws
        wb.SheetNames = ['data']

        const excelBuffer = XLSX.write(wb, { bookType, type: 'array' })
        const finalData = new Blob([excelBuffer], { type: fileType })

        FileSaver.saveAs(
          finalData,
          `GUDANG_${warehouseTitle}_${activeTabTitle}_${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
        )

        setTimeout(() => {
          setIsDownload(false)
          setFirstRows(0)
          setTotalRows(0)
        }, 2000)
      }, 500)
    } catch (error) {
      console.error('Download error:', error)
      setIsDownload(false)
      setFirstRows(0)
      setTotalRows(0)
    }
  }, 300)
}

export const handleDownloadExcel = async (
  warehouseName,
  activeTab,
  initialData,
  setIsDownload,
  setFirstRows,
  setTotalRows,
  fetchFunction,
  fetchParams,
) => {
  const warehouseTitle = warehouseName?.toUpperCase() ?? '-'
  const activeTabTitle = activeTab?.toUpperCase() ?? '-'

  setIsDownload(false)
  setFirstRows(0)
  setTotalRows(0)

  setTimeout(async () => {
    try {
      setIsDownload(true)

      const totalItems = initialData?.totalItems || 0
      const totalPages = initialData?.totalPages || 1

      setTotalRows(totalItems)
      setFirstRows(0)

      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      const bookType = 'xlsx'

      const exportHeader = ['Nama Inventori', 'Jumlah', 'Satuan']
      const ws = XLSX.utils.book_new()
      XLSX.utils.sheet_add_aoa(ws, [exportHeader])

      let allData = []
      let currentRow = 2

      for (let page = 0; page < totalPages; page++) {
        try {
          const response = await fetchFunction({
            ...fetchParams,
            page: page,
            size: 50,
          })

          const pageData = response?.items || []
          allData = [...allData, ...pageData]

          const currentProgress = Math.min(allData.length, totalItems)
          setFirstRows(currentProgress)

          const mappedData = pageData.map((row) => [
            row?.nameItem ?? '-',
            row?.total ?? 0,
            row?.unit ?? '-',
          ])

          if (mappedData.length > 0) {
            XLSX.utils.sheet_add_json(ws, mappedData, {
              origin: `A${currentRow}`,
              skipHeader: true,
            })
            currentRow += mappedData.length
          }

          if (page < totalPages - 1) {
            await new Promise((resolve) => setTimeout(resolve, 100))
          }
        } catch (error) {
          console.error(`Error fetching page ${page}:`, error)
        }
      }

      setFirstRows(totalItems)

      setTimeout(() => {
        styleTableSheet(ws)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = XLSX.write(wb, { bookType, type: 'array' })
        const finalData = new Blob([excelBuffer], { type: fileType })

        FileSaver.saveAs(
          finalData,
          `GUDANG_${warehouseTitle}_${activeTabTitle}_${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
        )

        setTimeout(() => {
          setIsDownload(false)
          setFirstRows(0)
          setTotalRows(0)
        }, 2000)
      }, 500)
    } catch (error) {
      console.error('Download error:', error)
      setIsDownload(false)
      setFirstRows(0)
      setTotalRows(0)
    }
  }, 300)
}
